import React from 'react';
import { render } from 'react-dom';
import App from './containers/App/App';
import './i18n';

render(<App />, document.getElementById('root'));
